import styled from 'styled-components';
import { theme } from '../theme';

export const PersonaCard = styled.div<{ $isUserPersona?: boolean }>`
  background: ${props => props.$isUserPersona
    ? `linear-gradient(135deg, ${theme.colors.primary}15 0%, ${theme.colors.secondary}15 100%)`
    : 'var(--bg-card)'};
  border: 2px solid ${props => props.$isUserPersona
    ? theme.colors.primary
    : 'var(--border-light)'};
  border-radius: ${theme.borderRadius.lg};
  padding: ${theme.spacing.lg};
  position: relative;
  transition: all 0.3s ease;
  box-shadow: ${props => props.$isUserPersona
    ? theme.shadows.medium
    : theme.shadows.light};
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: ${theme.shadows.heavy};
    border-color: ${props => props.$isUserPersona
      ? theme.colors.primary
      : 'var(--border-medium)'};
  }
`;

export const UserPersonaBadge = styled.div`
  position: absolute;
  top: ${theme.spacing.sm};
  right: ${theme.spacing.sm};
  background: ${theme.colors.gradients.primary};
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  box-shadow: ${theme.shadows.light};
`;

export const PersonaHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.lg};
`;

export const PersonaIcon = styled.div`
  font-size: 3rem;
  flex-shrink: 0;
  line-height: 1;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 2.5rem;
  }
`;

export const PersonaInfoSection = styled.div`
  flex: 1;
`;

export const PersonaName = styled.h3`
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 ${theme.spacing.xs} 0;
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1.3rem;
  }
`;

export const PersonaTagline = styled.p`
  font-size: 0.95rem;
  color: var(--text-secondary);
  margin: 0;
  line-height: 1.4;
`;

export const PersonaStats = styled.div`
  display: flex;
  gap: ${theme.spacing.lg};
  margin-bottom: ${theme.spacing.lg};
  padding-top: ${theme.spacing.md};
  border-top: 1px solid var(--border-light);
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.xs};
`;

export const StatValue = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${theme.colors.primary};
  
  @media (max-width: ${theme.breakpoints.mobile}) {
    font-size: 1.3rem;
  }
`;

export const StatLabel = styled.div`
  font-size: 0.85rem;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const JoinButton = styled.button<{ $isUserPersona?: boolean }>`
  width: 100%;
  padding: ${theme.spacing.md} ${theme.spacing.lg};
  background: ${props => props.$isUserPersona
    ? theme.colors.gradients.primary
    : 'rgba(255, 255, 255, 0.1)'};
  border: 2px solid ${props => props.$isUserPersona
    ? 'transparent'
    : theme.colors.border.orange};
  border-radius: ${theme.borderRadius.md};
  color: ${props => props.$isUserPersona ? 'white' : theme.colors.primary};
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.medium};
    background: ${props => props.$isUserPersona
      ? theme.colors.gradients.primary
      : theme.colors.primary};
    color: white;
    border-color: ${props => props.$isUserPersona
      ? 'transparent'
      : theme.colors.primary};
  }
  
  &:active {
    transform: translateY(0);
  }
`;

